module.exports = __webpack_public_path__ + "static/media/GuardiansOfAether-Gallery-07.12da4fa4.jpg";